<div class="px-3 mt-4 lg:my-3">
    <h1 class="learner  flex w-full justify-between lg:justify-start">Learner Report</h1>
</div>
<mrt-grid-template [gridOptions]="gridOptions" (actionEvent)="actionEvent($event)"></mrt-grid-template>
